import {
  SET_TRAILS,
  SET_SUGGESTED_TRAILS,
  TrailsActionsTypes,
} from "./TrailsActions";

interface Trails {
  trails: any[];
  suggestedTrails: any[];
}

const initialState: Trails = { trails: [], suggestedTrails: [] };

const TrailsReducer = (state = initialState, action: TrailsActionsTypes) => {
  switch (action.type) {
    case SET_TRAILS:
      return { ...state, trails: [...state?.trails, action?.payload] };

    case SET_SUGGESTED_TRAILS:
      return {
        ...state,
        suggestedTrails: action?.payload ? [...action?.payload] : [],
      };
    default:
      return state;
  }
};

export default TrailsReducer;
